import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./CreateProducts.css"; // Import your custom CSS file

const CreateProducts = () => {
  const [id, idchange] = useState("");
  const [name, namechange] = useState("");
  const [email, emailchange] = useState("");
  const [phone, phonechange] = useState("");
  const [active, activechange] = useState(true);
  const [validation, valchange] = useState(false);

  const navigate = useNavigate();

  const handlesubmit = (e) => {
    e.preventDefault();
    const empdata = { name, email, phone, active };

    fetch("https://dummyjson.com/users/add", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(empdata),
    })
      .then((res) => {
        alert("Saved successfully.");
        navigate("/listingproducts");
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  return (
    <div>
      <div className="row_create_prod">
        <div className="offset-lg-3_create_prod col-lg-6_create_prod">
          <form className="container_create_prod" onSubmit={handlesubmit}>
            <div className="card_create_prod">
              <div className="card-title_create_prod">
                <h2 className="create_title_prod">Create Products</h2>
              </div>
              <div className="card-body_create_prod">
                <div className="row_create_prod">
                  <div className="col-lg-12_create_prod">
                    <div className="form-group_create_prod">
                      <label>ID</label>
                      <input
                        value={id}
                        disabled="disabled"
                        className="form-control_create_prod"
                      ></input>
                    </div>
                  </div>

                  <div className="col-lg-12_create_prod">
                    <div className="form-group_create_prod">
                      <label>Name</label>
                      <input
                        required
                        value={name}
                        onMouseDown={(e) => valchange(true)}
                        onChange={(e) => namechange(e.target.value)}
                        className={`form-control_create_prod ${
                          name.length === 0 && validation
                            ? "is-invalid_create_prod"
                            : ""
                        }`}
                      ></input>
                      {name.length === 0 && validation && (
                        <span className="text-danger_create_prod">
                          Enter the name
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12_create_prod">
                    <div className="form-group_create_prod">
                      <label>Email</label>
                      <input
                        value={email}
                        onChange={(e) => emailchange(e.target.value)}
                        className="form-control_create_prod"
                      ></input>
                    </div>
                  </div>

                  <div className="col-lg-12_create_prod">
                    <div className="form-group_create_prod">
                      <label>Phone</label>
                      <input
                        value={phone}
                        onChange={(e) => phonechange(e.target.value)}
                        className="form-control_create_prod"
                      ></input>
                    </div>
                  </div>

                  <div className="col-lg-12_create_prod">
                    <div className="form-check_create_prod">
                      <input
                        checked={active}
                        onChange={(e) => activechange(e.target.checked)}
                        type="checkbox"
                        className="form-check-input_create_prod"
                      ></input>
                      <label className="form-check-label_create_prod">
                        Is Active
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-12_create_prod">
                    <div className="form-group_create_prod">
                      <button
                        className="btn_create_prod btn-success_create_prod"
                        type="submit"
                      >
                        Save
                      </button>
                      <Link
                        to="/listingproducts"
                        className="btn_create_prod btn-danger_create_prod"
                      >
                        Back
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateProducts;
